import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keyvalue' })
export class KeyValuePipe implements PipeTransform {
    transform(value, args?: string[]): any {
        const keys = [];
        if (value) {
            for (const key of Object.keys(value)) {
                keys.push({ key, value: value[key] });
            }
            return keys;
        } else {
            return [];
        }
    }
}
